export default __webpack_public_path__ + "media/src/assets/images/MapPinPickupCrossdock-50b3303ee17bbccc583b3b5795c895ea.svg";